module.exports = __webpack_public_path__ + "static/img/portfolio3.3d64fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/portfolio3.jpg
// module id = i6Rn
// module chunks = 0